<template>
  <div>
    <div class="module_addi">
      <el-select v-model="year" @change="surveyList()" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="btn_outer">
        <el-button type="primary" plain @click="toAddsurvey2"><i class="cloudicon ci_modify"></i> 数据填报</el-button>
      </div>
    </div>
    <div class="user_module">
      <div class="module_tab_cont cyyddc">
        <el-table :data="tablelist" stripe :cell-class-name="ccn" @cell-click="view" style="width: 100%">
          <el-table-column prop="pc_num" label="批次" width="200px"></el-table-column>
          <el-table-column prop="statusName" label="数据填报情况" width="260px"></el-table-column>
          <el-table-column prop="refer_time" label="提交时间" width="200px"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
	        <template slot-scope="scope">
            <span class="btn_edi"  @click="modify(scope.row.id)" style="font-size: 14px;">编辑</span>
	          <!--<div class="btn_outer"><el-button @click="modify(scope.row.id)" type="primary" plain size="small"><i class="cloudicon ci_modify"></i>编辑</el-button>-->
	           <!-- <el-button @click="view(scope.row.id)" type="primary" plain size="small"><i class="cloudicon ci_property"></i>查看</el-button>-->
	          <!--</div>-->
	        </template>
	      </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="940px">
      <addsurvey2 @emitClose="close"></addsurvey2>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisibleEdit"
      @close="close2"
      width="940px">
		<editsurvey2 @emitEditClose="close2" v-if="dialogVisibleEdit" :editId="editId" :mode="mode"></editsurvey2>
    </el-dialog>
  </div>
</template>

<script>
export default {
  created() {
    this.surveyList();
  },
  name: 'usersurvey2',
  inject:['reload'],
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      tablelist: [],
      total:0,
      value2: '',
      dialogVisible: false,
      dialogVisibleEdit:false,
	  editId:'',
      year:2020,
      options: [{
        value: '2020',
        label: '2020'
      }, {
        value: '2019',
        label: '2019'
      }, {
        value: '2018',
        label: '2018'
      }],
    }
  },
  methods: {
    ccn(row) {
      if (row.row.statusName.indexOf("填写")>-1 && row.columnIndex === 1) {
        return 'statwrite'
      } else if (row.row.statusName.indexOf("提交")>-1 && row.columnIndex === 1) {
        return 'statsubmit'
      }
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.surveyList();
    },
    async toAddsurvey2() {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/data/getDcId');
      if(res.data.data.submited==0){
        this.$message.error('当前不在申报期，暂不可填报');
        return
      }
      if(res.data.data.submited==1){
        this.$message.error('本申报期仅可填报一次！');
        return
      }
      if (res.data.data.year != null && res.data.data.pc_num != null) {
        this.dialogVisible = true;
      } else {
        this.$message.error('当前不在申报期，暂不可填报');
      }
    },
    modify(id){
    	this.editId = id;
    	this.dialogVisibleEdit = true;
      this.mode='edit';
    },

    view(row,column){
    	if(column.label!='操作'){
        this.editId = row.id;
        this.dialogVisibleEdit = true;
        this.mode='view';
      }
    },

    close() {
      this.dialogVisible = false;
      this.reload()
    },
    close2(){
    	this.dialogVisibleEdit = false;
    	this.reload()
    },
    async surveyList(){
      this.options=[];
      var curryear=new Date().getFullYear();
      this.year=curryear;
      for (var i=curryear;i>=2018;i--){
        var option={
          value: ''+i,
          label: ''+i
        }
        this.options.push(option)
      }
      let res = await this.$ajax.post(this.bUrl + 'api/portal/data/indexDc?year='+this.year+"&page="+this.currentPage+"&pagesize="+this.pagesize);
      this.tablelist=res.data.data.list;
      this.tablelist.forEach(item=>{
        if(item.status===1){
          item.statusName="正在填写";
        }else if(item.status===2){
          item.statusName="已提交";
        }else {
          item.statusName="";
        }
      });
      this.total=res.data.data.total;
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_tab_cont {
  margin-top: 25px;
}

.module_addi {
  width: 100%;
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: space-between;
}

.ci_modify {
  font-size: 24px;
}
.ci_property{
	font-size: 20px;
}
.dialog_head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.dialog_head .tit {
  font-size: 16px;
  font-weight: bold;
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/usersurvey2.vue